module.exports = __webpack_public_path__ + "media/images/vector/vector2-de57113e375e3deccd22faa4c43dabd7.png";